import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { POST_URL } from '@utils/api/endpoints.ts';

export const useUpdateOrganizationLogo = (organizationId: number) => {
  const queryClient = useQueryClient();

  const updateUserLogo = async (logoFile: File) => {
    const formData = new FormData();
    formData.append('logo', logoFile);

    await Axios.patch(
      `${POST_URL(organizationId.toString()).updateOrganizationLogo}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
  };

  return useMutation<void, AxiosError<BaseError>, File>(updateUserLogo, {
    onSuccess: () => {
      queryClient.invalidateQueries(['organizationLogo', organizationId]);
    },
    useErrorBoundary: false
  });
};
